import { g as e, _ as a, h as l } from "../../../_rollupPluginBabelHelpers-d2f9cf82.js";
import t, { forwardRef as d, useRef as r } from "react";
var i = ["checked", "defaultChecked", "onChange", "className", "style", "disabled", "id", "labelId", "name", "aria-label", "aria-labelledby", "children"],
  n = d(function (d, n) {
    var c = d.checked,
      o = d.defaultChecked,
      s = d.onChange,
      b = d.className,
      u = void 0 === b ? "" : b,
      f = d.style,
      h = d.disabled,
      m = void 0 !== h && h,
      y = d.id,
      p = d.labelId,
      k = d.name,
      g = d["aria-label"],
      C = d["aria-labelledby"],
      v = d.children,
      N = e(d, i),
      w = t.useState(!!o),
      I = a(w, 2),
      S = I[0],
      _ = I[1],
      j = "boolean" == typeof c,
      x = j ? c : S,
      B = r(p || y || "switch-".concat(Math.random().toString(36).substr(2, 9))).current;
    return t.createElement("button", l({
      type: "button",
      role: "switch",
      "aria-checked": x,
      "aria-label": g,
      "aria-labelledby": C,
      disabled: m,
      className: u,
      style: f,
      onClick: function (e) {
        m || (j ? s && s(!c, e) : _(function (a) {
          return s && s(!a, e), !a;
        }));
      },
      ref: n,
      id: B,
      name: k
    }, N), "function" == typeof v ? v({
      checked: x,
      disabled: m
    }) : v);
  });
export { n as default };